/**
 * AuthLayout — shell for authentication pages.
 * Centered content with minimal chrome.
 */

import { Outlet, Link } from 'react-router-dom';
import { Container } from '@/components/ui';
import { BrandLogo } from '@/components/layout';

export function AuthLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <main className="flex flex-1 items-center justify-center p-4">
        <Container maxWidth="sm">
          <div className="flex flex-col gap-8">
            <Link
              to="/"
              className="flex items-center justify-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600/15 focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              aria-label="UNIVIBE home"
            >
              <BrandLogo className="h-5 w-auto sm:h-6" />
            </Link>
            <Outlet />
          </div>
        </Container>
      </main>
    </div>
  );
}
